var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "root" }, [
      _c("div", { staticClass: "header" }, [
        _vm._v("\n    Fim de semana e casa limpa!\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "discount" }, [
          _c("img", { attrs: { src: "static/dashboard/discount.svg" } }),
          _vm._v(" "),
          _c("div", [
            _vm._v("Utilize o cupom "),
            _c("b", [_vm._v("QUERO10")]),
            _vm._v(" e ganhe um super desconto na sua limpeza.")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "restriction" }, [
          _vm._v("\n      Válido para limpezas avulsas agendadas até "),
          _c("b", [_vm._v("Sábado, 15/01")]),
          _vm._v(".  Cupom não cumulativo com outros cupons.\n    ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b1fabc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b1fabc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banners/Banner.vue
// module id = null
// module chunks = 